import React from 'react';
import { TabObjectType, EventKeys } from '../tabs-types';

const getTabDirection = (direction: string): number | null => {
  if (direction === EventKeys.ArrowLeft || direction === EventKeys.ArrowUp) {
    return -1;
  }
  if (direction === EventKeys.ArrowRight || direction === EventKeys.ArrowDown) {
    return 1;
  }

  return null;
};

const switchTabOnArrowPress = (tabsArray: TabObjectType[], event: React.KeyboardEvent<HTMLDivElement>) => {
  const directionValue = getTabDirection(event.key);
  const element = event.target as HTMLElement;
  const targetIndex = Number(element.parentElement?.getAttribute('data-index'));
  if (directionValue && targetIndex > -1) {
    const indexToFocus = targetIndex + directionValue;
    if (indexToFocus < 0) {
      tabsArray[Number(tabsArray.length - 1)].buttonRef?.current?.focus();
    } else if (indexToFocus >= tabsArray.length) {
      tabsArray[0].buttonRef?.current?.focus();
    } else {
      tabsArray[Number(indexToFocus)].buttonRef?.current?.focus();
    }
  }
};

export const keydownEventListener = (
  sectionRef: React.RefObject<HTMLElement>,
  tabsArray: TabObjectType[],
  event: React.KeyboardEvent<HTMLDivElement>,
): void => {
  const { key } = event;
  switch (key) {
    case EventKeys.End:
      event.preventDefault();
      if (sectionRef.current) {
        tabsArray[Number(tabsArray) - 1].buttonRef?.current?.focus();
      }
      break;
    case EventKeys.Home:
      event.preventDefault();
      if (sectionRef.current) {
        tabsArray[0].buttonRef?.current?.focus();
      }
      break;
    case EventKeys.ArrowUp:
    case EventKeys.ArrowDown:
      switchTabOnArrowPress(tabsArray, event);
      break;
    default:
      break;
  }
};

export const keyupEventListener = (tabsArray: TabObjectType[], event: React.KeyboardEvent<HTMLDivElement>): void => {
  const { key } = event;
  if (key === EventKeys.ArrowLeft || key === EventKeys.ArrowRight) {
    switchTabOnArrowPress(tabsArray, event);
  }
};
